import { useTranslation } from "react-i18next";

import { getEventTypeStrategy } from "./eventTypeStrategies/getEventTypeStrategy";

import BadgeCurrencyCell from "@/components/ui/v1/table/BadgeCurrencyCell";
import { DateTimeCell } from "@/components/ui/v1/table/TableCells";
import { BudgetEventType } from "@/lib/utils/clientBudgetEventTypeMap";
import { TableColumn } from "@/types/table/tableProps";
import { TransactionType } from "@/types/transaction/TransactionType";

export const useTransactionTableColumns = () => {
  const { t } = useTranslation();

  const transactionTableColumns: TableColumn[] = [
    {
      header: t("common.dateTime"),
      accessor: "timestamp",
      width: "10%",
      sortable: false,
      Cell: (row: TransactionType) => (
        <DateTimeCell timestamp={row?.timestamp} />
      ),
    },
    {
      header: t("common.type"),
      accessor: "eventType",
      width: "15%",
      sortable: false,
      Cell: (row: TransactionType): JSX.Element => {
        const strategy = getEventTypeStrategy(row.eventType);
        const { type } = strategy.getTypeAndDescription(row, t);
        return type;
      },
    },
    {
      header: t("common.description"),
      accessor: "description",
      width: "30%",
      sortable: false,
      Cell: (row: TransactionType): JSX.Element => {
        const strategy = getEventTypeStrategy(row.eventType);
        const { description } = strategy.getTypeAndDescription(row, t);
        return (
          <div>
            {description}
            {row.eventData.comments && <div>{row.eventData.comments}</div>}
          </div>
        );
      },
    },
    {
      header: t("common.amount"),
      accessor: "amount",
      width: "12%",
      sortable: false,
      Cell: (row: TransactionType) =>
        ![
          BudgetEventType.OVERSPEND_ALLOWED_CHANGED,
          BudgetEventType.PAYMENT_TYPE_UPDATED,
        ].includes(row.eventType) &&
        row.eventData.amount !== null &&
        row.eventData.amount !== undefined ? (
            <BadgeCurrencyCell
              direction={row.direction}
              type={row.type}
              value={row.eventData.amount}
            />
          ) : (
            <span>-</span>
          ),
    },
  ];

  return {
    transactionTableColumns,
  };
};
